import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Docs from './docs/Docs';
import '../node_modules/highlight.js/styles/tomorrow.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTh, faCaretUp } from '@fortawesome/free-solid-svg-icons';

library.add(faTh, faCaretUp);

ReactDOM.render(<Docs />, document.getElementById('root'));
